import { AwaitResponse } from '@general/js/utils/MockUtils';
import { terminationReasonFlexCodes, fundNames, changeProductReferenceData } from '@/constants/ChangeCover/MockAPIResult';
import { mpCoverDetails, MemberPolicies } from '@/constants/MyCoverServicesMockApiData';
import ChangeProductAbstractServices from './ChangeProductAbstractServices';

export default class ChangeProductServices extends ChangeProductAbstractServices {
  static async getChangeProductReferenceData() {
    return AwaitResponse(changeProductReferenceData);
  }

  static async getMembershipDetails() {
    return AwaitResponse(mpCoverDetails);
  }

  static async getRecommendedProducts(payload, isScenarioTwo = false) {
    const recommendationsResponse = {
      recommendations: [
        {
          recommendationName: 'Ultimate Hospital Gold',
          recommendationRanking: 1,
          quoteId: '0f07c1e4-057b-ef11-ac21-6045bd3cfb3c',
          quoteExpired: false,
          products: [
            {
              productName: 'Ultimate Hospital Gold',
              productCode: 'J19',
              productType: 'Hospital',
              productDescription: 'Designed to give you complete peace of mind.  Comprehensive cover for peace of mind.  ',
              productExcess: '500',
              productUsp: 'Comprehensive cover for peace of mind.',
              eligibleForABD: false,
              productGuideLink: 'https://stdhlwebdevdata001.blob.core.windows.net/pdfdocuments/guides/open/UltimateHospitalGold500.pdf',
              productExcessType: 'MEM_EXCESS',
              productProperties: [
                {
                  flexiLimit: false,
                  propertyName: 'Assisted reproductive services',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for fertility treatments or procedures.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Back, neck and spine',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the investigation and treatment of the back, neck and spinal column, including spinal fusion.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Blood',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the investigation and treatment of blood and blood-related conditions.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Bone, joint and muscle',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the investigation and treatment of diseases, disorders and injuries of the musculoskeletal system.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Brain and nervous system',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the investigation and treatment of the brain, brain-related conditions, spinal cord and peripheral nervous system.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Breast surgery (medically necessary)',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the investigation and treatment of breast disorders and associated lymph nodes, and reconstruction and/or reduction following breast surgery or a preventative mastectomy. This clinical category does not require benefits to be paid for cosmetic breast surgery that is not medically necessary.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Cataracts',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for surgery to remove a cataract and replace with an artificial lens.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Chemotherapy, radiotherapy and immunotherapy for cancer',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for chemotherapy, radiotherapy and immunotherapy for the treatment of cancer or benign tumours.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Dental surgery',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for surgery to the teeth and gums.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Diabetes management (excluding insulin pumps)',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the investigation and management of diabetes.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Dialysis for chronic kidney failure',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for dialysis treatment for chronic kidney failure.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Digestive system',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the investigation and treatment of the digestive system, including the oesophagus, stomach, gall bladder, pancreas, spleen, liver and bowel.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Ear, nose and throat',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the investigation and treatment of the ear, nose, throat, middle ear, thyroid, parathyroid, larynx, lymph nodes and related areas of the head and neck.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Eye (not cataracts)',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the investigation and treatment of the eye and the contents of the eye socket.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Gastrointestinal endoscopy',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the diagnosis, investigation and treatment of the internal parts of the gastrointestinal system using an endoscope.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Gynaecology',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the investigation and treatment of the female reproductive system.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Heart and vascular system',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the investigation and treatment of the heart, heart-related conditions and vascular system.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Hernia and appendix',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the investigation and treatment of a hernia or appendicitis.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Hospital psychiatric services',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the treatment and care of patients with psychiatric, mental, addiction or behavioural disorders.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Implantation of hearing devices',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment to correct hearing loss, including implantation of a prosthetic hearing device.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Insulin pumps',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the provision and replacement of insulin pumps for treatment of diabetes.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Joint reconstructions',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for surgery for joint reconstructions.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Joint replacements',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for surgery for joint replacements, including revisions, resurfacing, partial replacements and removal of prostheses.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Kidney and bladder',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the investigation and treatment of the kidney, adrenal gland and bladder.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Lung and chest',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the investigation and treatment of the lungs, lung-related conditions, mediastinum and chest.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Male reproductive system',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the investigation and treatment of the male reproductive system including the prostate.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Miscarriage and termination of pregnancy',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the investigation and treatment of a miscarriage or for termination of pregnancy.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Pain management',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for pain management that does not require the insertion or surgical management of a device.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Pain management with device',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the implantation, replacement or other surgical management of a device required for the treatment of pain. For example: treatment of nerve pain, back pain, and pain caused by coronary heart disease with a device (for example an infusion pump or neurostimulator). Treatment of pain that does not require a device is listed separately under Pain management.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Palliative care',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for care where the intent is primarily providing quality of life for a patient with a terminal illness, including treatment to alleviate and manage pain.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Plastic and reconstructive surgery (medically necessary)',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment which is medically necessary for the investigation and treatment of any physical deformity, whether acquired as a result of illness or accident, or congenital.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Podiatric surgery (by a registered podiatric surgeon)',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the investigation and treatment of conditions affecting the foot and/or ankle, provided by a registered podiatric surgeon but limited to cover for:· accommodation; and· the cost of a prosthesis as listed in the prostheses list set out in the Private Health Insurance (Prostheses) Rules, as in force from time to time.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Pregnancy and birth',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for investigation and treatment of conditions associated with pregnancy and child birth.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Rehabilitation',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for physical rehabilitation for a patient related to surgery or illness.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Skin',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the investigation and treatment of skin, skin-related conditions and nails. The removal of foreign bodies is also included.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Sleep studies',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the investigation of sleep patterns and anomalies.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Tonsils, adenoids and grommets',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment of the tonsils, adenoids and insertion or removal of grommets.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Weight loss surgery',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for surgery that is designed to reduce a person’s weight, remove excess skin due to weight loss and reversal of a bariatric procedure.',
                  waitingPeriod: null,
                },
              ],
            },
          ],
        },
        {
          recommendationName: 'Advantage Hospital Silver Plus',
          recommendationRanking: 2,
          quoteId: '1ec7c1e4-057b-ef11-ac21-6045bd3cd4ae',
          quoteExpired: false,
          products: [
            {
              productName: 'Advantage Hospital Silver Plus',
              productCode: 'J22',
              productType: 'Hospital',
              productDescription: "Hospital cover for most services. Don't pay for things you don't need to use. Only pay for what you need. ",
              productExcess: '500:750',
              productUsp: 'Only pay for what you need.',
              eligibleForABD: true,
              productGuideLink: 'https://stdhlwebdevdata001.blob.core.windows.net/pdfdocuments/guides/open/AdvantageHospitalSilverPlus.pdf',
              productExcessType: 'MEM_EXCESS',
              productProperties: [
                {
                  flexiLimit: false,
                  propertyName: 'Assisted reproductive services',
                  propertyValue: 'Excluded',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for fertility treatments or procedures.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Back, neck and spine',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the investigation and treatment of the back, neck and spinal column, including spinal fusion.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Blood',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the investigation and treatment of blood and blood-related conditions.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Bone, joint and muscle',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the investigation and treatment of diseases, disorders and injuries of the musculoskeletal system.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Brain and nervous system',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the investigation and treatment of the brain, brain-related conditions, spinal cord and peripheral nervous system.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Breast surgery (medically necessary)',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the investigation and treatment of breast disorders and associated lymph nodes, and reconstruction and/or reduction following breast surgery or a preventative mastectomy. This clinical category does not require benefits to be paid for cosmetic breast surgery that is not medically necessary.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Cataracts',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for surgery to remove a cataract and replace with an artificial lens.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Chemotherapy, radiotherapy and immunotherapy for cancer',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for chemotherapy, radiotherapy and immunotherapy for the treatment of cancer or benign tumours.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Dental surgery',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for surgery to the teeth and gums.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Diabetes management (excluding insulin pumps)',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the investigation and management of diabetes.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Dialysis for chronic kidney failure',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for dialysis treatment for chronic kidney failure.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Digestive system',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the investigation and treatment of the digestive system, including the oesophagus, stomach, gall bladder, pancreas, spleen, liver and bowel.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Ear, nose and throat',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the investigation and treatment of the ear, nose, throat, middle ear, thyroid, parathyroid, larynx, lymph nodes and related areas of the head and neck.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Eye (not cataracts)',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the investigation and treatment of the eye and the contents of the eye socket.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Gastrointestinal endoscopy',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the diagnosis, investigation and treatment of the internal parts of the gastrointestinal system using an endoscope.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Gynaecology',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the investigation and treatment of the female reproductive system.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Heart and vascular system',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the investigation and treatment of the heart, heart-related conditions and vascular system.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Hernia and appendix',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the investigation and treatment of a hernia or appendicitis.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Hospital psychiatric services',
                  propertyValue: 'Restricted',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the treatment and care of patients with psychiatric, mental, addiction or behavioural disorders.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Implantation of hearing devices',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment to correct hearing loss, including implantation of a prosthetic hearing device.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Insulin pumps',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the provision and replacement of insulin pumps for treatment of diabetes.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Joint reconstructions',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for surgery for joint reconstructions.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Joint replacements',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for surgery for joint replacements, including revisions, resurfacing, partial replacements and removal of prostheses.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Kidney and bladder',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the investigation and treatment of the kidney, adrenal gland and bladder.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Lung and chest',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the investigation and treatment of the lungs, lung-related conditions, mediastinum and chest.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Male reproductive system',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the investigation and treatment of the male reproductive system including the prostate.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Miscarriage and termination of pregnancy',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the investigation and treatment of a miscarriage or for termination of pregnancy.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Pain management',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for pain management that does not require the insertion or surgical management of a device.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Pain management with device',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the implantation, replacement or other surgical management of a device required for the treatment of pain. For example: treatment of nerve pain, back pain, and pain caused by coronary heart disease with a device (for example an infusion pump or neurostimulator). Treatment of pain that does not require a device is listed separately under Pain management.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Palliative care',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for care where the intent is primarily providing quality of life for a patient with a terminal illness, including treatment to alleviate and manage pain.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Plastic and reconstructive surgery (medically necessary)',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment which is medically necessary for the investigation and treatment of any physical deformity, whether acquired as a result of illness or accident, or congenital.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Podiatric surgery (by a registered podiatric surgeon)',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the investigation and treatment of conditions affecting the foot and/or ankle, provided by a registered podiatric surgeon but limited to cover for:· accommodation; and· the cost of a prosthesis as listed in the prostheses list set out in the Private Health Insurance (Prostheses) Rules, as in force from time to time.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Pregnancy and birth',
                  propertyValue: 'Excluded',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for investigation and treatment of conditions associated with pregnancy and child birth.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Rehabilitation',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for physical rehabilitation for a patient related to surgery or illness.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Skin',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the investigation and treatment of skin, skin-related conditions and nails. The removal of foreign bodies is also included.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Sleep studies',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the investigation of sleep patterns and anomalies.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Tonsils, adenoids and grommets',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment of the tonsils, adenoids and insertion or removal of grommets.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Weight loss surgery',
                  propertyValue: 'Excluded',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for surgery that is designed to reduce a person’s weight, remove excess skin due to weight loss and reversal of a bariatric procedure.',
                  waitingPeriod: null,
                },
              ],
            },
          ],
        },
      ],
      existingProducts: {
        existingProductName: 'Core Hospital Silver & Value Extras',
        products: [
          {
            productName: 'Value Extras',
            productCode: 'I4',
            productType: 'Extras',
            productDescription: 'Cover for a wide range of extras with great annual limits. Generous annual limits on a wide range of extras.  ',
            productExcess: '',
            productUsp: 'Generous annual limits on a wide range of extras.',
            eligibleForABD: false,
            productGuideLink: 'https://stdhlwebdevdata001.blob.core.windows.net/pdfdocuments/guides/open/ValueExtras.pdf',
            productExcessType: '',
            productProperties: [
              {
                flexiLimit: false,
                propertyName: 'Ambulance treatment',
                propertyValue: '$ Unlimited',
                propertyType: 'Extras',
                qualifyingStatements:
                  "Comprehensive cover for ambulance services by state-appointed ambulance providers across Australia. No limits apply, so there's no need for a separate subscription. Cover includes: emergency services, non-emergency dispatch, mobile intensive care, air and sea ambulance services. Transport services by Patient Transport vehicles are not ambulance services and are not claimable",
                waitingPeriod: '2 months',
              },
              {
                flexiLimit: true,
                propertyName: 'Antenatal and postnatal services',
                propertyValue: 'Included',
                propertyType: 'Extras',
                qualifyingStatements:
                  'Antenatal services are provided before having a baby and postnatal services are provided after having a baby. Benefits are payable for consultations and classes with a midwife or physiotherapist in private practice. Treatment claims through Medicare cannot be covered.',
                waitingPeriod: null,
              },
              {
                flexiLimit: true,
                propertyName: 'Audiology',
                propertyValue: 'Included',
                propertyType: 'Extras',
                qualifyingStatements: null,
                waitingPeriod: null,
              },
              {
                flexiLimit: true,
                propertyName: 'Chiropractic/Osteopathic',
                propertyValue: 'Included',
                propertyType: 'Extras',
                qualifyingStatements: null,
                waitingPeriod: null,
              },
              {
                flexiLimit: true,
                propertyName: 'Dietitian',
                propertyValue: 'Included',
                propertyType: 'Extras',
                qualifyingStatements: null,
                waitingPeriod: null,
              },
              {
                flexiLimit: true,
                propertyName: 'Exercise physiology',
                propertyValue: 'Included',
                propertyType: 'Extras',
                qualifyingStatements: null,
                waitingPeriod: null,
              },
              {
                flexiLimit: true,
                propertyName: 'Eye therapy',
                propertyValue: 'Included',
                propertyType: 'Extras',
                qualifyingStatements: null,
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Flexi-limit',
                propertyValue: '$1100 per person',
                propertyType: 'Extras',
                qualifyingStatements:
                  'The flexi-limit can be claimed across the range of included treatments, or you can choose to use it all on your favourite included treatment.',
                waitingPeriod: '2 months',
              },
              {
                flexiLimit: false,
                propertyName: 'General and preventive dental',
                propertyValue: '$900 per person',
                propertyType: 'Extras',
                qualifyingStatements:
                  'Includes examinations, scale & clean, fluoride treatments, x-rays, simple extractions, most fillings, mouth-guards and other simple, dental treatments. *Some dental items are limited in the number of times they can be claimed in a year or appointment. Some are not payable in combination with others. And some may not attract a benefit at all.',
                waitingPeriod: '2 months',
              },
              {
                flexiLimit: false,
                propertyName: 'Health and wellbeing',
                propertyValue: '$300 per person',
                propertyType: 'Extras',
                qualifyingStatements:
                  'Where the provider is recognised by the Australian Regional Health Group the following alternative therapies are payable: acupuncture, myotherapy and remedial massage. No benefit payable for any prescribed medications, herbal or dietary preparations. Included in this category is physiotherapy group therapy sessions and classes and excerise physiology group therapy. Benefits are available for approved health screening tests and programs.',
                waitingPeriod: '2 months',
              },
              {
                flexiLimit: false,
                propertyName: 'Laser refractive eye surgery',
                propertyValue: 'Excluded',
                propertyType: 'Extras',
                qualifyingStatements: 'Payable for LASIK, PRK or smile eye surgery in recognised day surgery centre every 2 financial years.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Major dental',
                propertyValue: '$900 per person',
                propertyType: 'Extras',
                qualifyingStatements: 'Complex dental services such as root canal therapy, surgical extractions, gum disease, dentures, implants, crowns and bridges.',
                waitingPeriod: '12 months',
              },
              {
                flexiLimit: false,
                propertyName: 'Medically prescribed devices and appliances',
                propertyValue: '$1000 per person',
                propertyType: 'Extras',
                qualifyingStatements:
                  'A wide range of aids and appliances that help treat or supporta medial condition. Common examples include hearing aids, PAP machines, blood glucose monitors, mobility aids, compression garments, foot orthotics and nebulisers.',
                waitingPeriod: '2-12 months',
              },
              {
                flexiLimit: true,
                propertyName: 'Occupational therapy',
                propertyValue: 'Included',
                propertyType: 'Extras',
                qualifyingStatements: null,
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Optical',
                propertyValue: '$255 per person',
                propertyType: 'Extras',
                qualifyingStatements: 'Provision of presciption glasses and contact lenses.',
                waitingPeriod: '2 months',
              },
              {
                flexiLimit: false,
                propertyName: 'Orthodontics',
                propertyValue: '$800 per person',
                propertyType: 'Extras',
                qualifyingStatements: 'Dental services to address and realign bites',
                waitingPeriod: '12 months',
              },
              {
                flexiLimit: true,
                propertyName: 'Pharmacy and vaccinations',
                propertyValue: 'Included',
                propertyType: 'Extras',
                qualifyingStatements: 'The benefit is payable on non-PBS pharmaceuticals only and applies to the cost in excess of the current PBS amount.',
                waitingPeriod: null,
              },
              {
                flexiLimit: true,
                propertyName: 'Physiotherapy',
                propertyValue: 'Included',
                propertyType: 'Extras',
                qualifyingStatements: null,
                waitingPeriod: null,
              },
              {
                flexiLimit: true,
                propertyName: 'Podiatry/Chiropody',
                propertyValue: 'Included',
                propertyType: 'Extras',
                qualifyingStatements: null,
                waitingPeriod: null,
              },
              {
                flexiLimit: true,
                propertyName: 'Psychology',
                propertyValue: 'Included',
                propertyType: 'Extras',
                qualifyingStatements: 'Treatment claimed through Medicare cannot be covered.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'School accidents',
                propertyValue: '$600 per person',
                propertyType: 'Extras',
                qualifyingStatements:
                  'Additional benefits for costs resulting from a school accident to your child. To cover the gaps after your extras benefits have been provided, excludes Medicare services.',
                waitingPeriod: '2 months',
              },
              {
                flexiLimit: true,
                propertyName: 'Speech therapy',
                propertyValue: 'Included',
                propertyType: 'Extras',
                qualifyingStatements: null,
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Surgical tooth removal',
                propertyValue: 'Included with Major dental',
                propertyType: 'Extras',
                qualifyingStatements: null,
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Travel vaccinations',
                propertyValue: 'Excluded',
                propertyType: 'Extras',
                qualifyingStatements: null,
                waitingPeriod: null,
              },
            ],
          },
          {
            productName: 'Core Hospital Silver',
            productCode: 'J21',
            productType: 'Hospital',
            productDescription: 'Hospital cover tailored to keep costs affordable. Value-packed hospital cover tailored for you.   ',
            productExcess: '500:750',
            productUsp: 'Value-packed hospital cover tailored for you.',
            eligibleForABD: true,
            productGuideLink: 'https://stdhlwebdevdata001.blob.core.windows.net/pdfdocuments/guides/open/CoreHospitalSilverPlus.pdf',
            productExcessType: 'MEM_EXCESS',
            productProperties: [
              {
                flexiLimit: false,
                propertyName: 'Assisted reproductive services',
                propertyValue: 'Excluded',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for fertility treatments or procedures.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Back, neck and spine',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the investigation and treatment of the back, neck and spinal column, including spinal fusion.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Blood',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the investigation and treatment of blood and blood-related conditions.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Bone, joint and muscle',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the investigation and treatment of diseases, disorders and injuries of the musculoskeletal system.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Brain and nervous system',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the investigation and treatment of the brain, brain-related conditions, spinal cord and peripheral nervous system.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Breast surgery (medically necessary)',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements:
                  'Hospital treatment for the investigation and treatment of breast disorders and associated lymph nodes, and reconstruction and/or reduction following breast surgery or a preventative mastectomy. This clinical category does not require benefits to be paid for cosmetic breast surgery that is not medically necessary.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Cataracts',
                propertyValue: 'Excluded',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for surgery to remove a cataract and replace with an artificial lens.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Chemotherapy, radiotherapy and immunotherapy for cancer',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for chemotherapy, radiotherapy and immunotherapy for the treatment of cancer or benign tumours.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Dental surgery',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for surgery to the teeth and gums.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Diabetes management (excluding insulin pumps)',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the investigation and management of diabetes.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Dialysis for chronic kidney failure',
                propertyValue: 'Excluded',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for dialysis treatment for chronic kidney failure.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Digestive system',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements:
                  'Hospital treatment for the investigation and treatment of the digestive system, including the oesophagus, stomach, gall bladder, pancreas, spleen, liver and bowel.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Ear, nose and throat',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements:
                  'Hospital treatment for the investigation and treatment of the ear, nose, throat, middle ear, thyroid, parathyroid, larynx, lymph nodes and related areas of the head and neck.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Eye (not cataracts)',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the investigation and treatment of the eye and the contents of the eye socket.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Gastrointestinal endoscopy',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the diagnosis, investigation and treatment of the internal parts of the gastrointestinal system using an endoscope.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Gynaecology',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the investigation and treatment of the female reproductive system.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Heart and vascular system',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the investigation and treatment of the heart, heart-related conditions and vascular system.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Hernia and appendix',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the investigation and treatment of a hernia or appendicitis.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Hospital psychiatric services',
                propertyValue: 'Restricted',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the treatment and care of patients with psychiatric, mental, addiction or behavioural disorders.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Implantation of hearing devices',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment to correct hearing loss, including implantation of a prosthetic hearing device.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Insulin pumps',
                propertyValue: 'Excluded',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the provision and replacement of insulin pumps for treatment of diabetes.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Joint reconstructions',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for surgery for joint reconstructions.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Joint replacements',
                propertyValue: 'Excluded',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for surgery for joint replacements, including revisions, resurfacing, partial replacements and removal of prostheses.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Kidney and bladder',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the investigation and treatment of the kidney, adrenal gland and bladder.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Lung and chest',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the investigation and treatment of the lungs, lung-related conditions, mediastinum and chest.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Male reproductive system',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the investigation and treatment of the male reproductive system including the prostate.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Miscarriage and termination of pregnancy',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the investigation and treatment of a miscarriage or for termination of pregnancy.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Pain management',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for pain management that does not require the insertion or surgical management of a device.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Pain management with device',
                propertyValue: 'Excluded',
                propertyType: 'Hospital',
                qualifyingStatements:
                  'Hospital treatment for the implantation, replacement or other surgical management of a device required for the treatment of pain. For example: treatment of nerve pain, back pain, and pain caused by coronary heart disease with a device (for example an infusion pump or neurostimulator). Treatment of pain that does not require a device is listed separately under Pain management.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Palliative care',
                propertyValue: 'Restricted',
                propertyType: 'Hospital',
                qualifyingStatements:
                  'Hospital treatment for care where the intent is primarily providing quality of life for a patient with a terminal illness, including treatment to alleviate and manage pain.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Plastic and reconstructive surgery (medically necessary)',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements:
                  'Hospital treatment which is medically necessary for the investigation and treatment of any physical deformity, whether acquired as a result of illness or accident, or congenital.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Podiatric surgery (by a registered podiatric surgeon)',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements:
                  'Hospital treatment for the investigation and treatment of conditions affecting the foot and/or ankle, provided by a registered podiatric surgeon but limited to cover for:· accommodation; and· the cost of a prosthesis as listed in the prostheses list set out in the Private Health Insurance (Prostheses) Rules, as in force from time to time.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Pregnancy and birth',
                propertyValue: 'Excluded',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for investigation and treatment of conditions associated with pregnancy and child birth.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Rehabilitation',
                propertyValue: 'Restricted',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for physical rehabilitation for a patient related to surgery or illness.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Skin',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements:
                  'Hospital treatment for the investigation and treatment of skin, skin-related conditions and nails. The removal of foreign bodies is also included.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Sleep studies',
                propertyValue: 'Excluded',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the investigation of sleep patterns and anomalies.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Tonsils, adenoids and grommets',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment of the tonsils, adenoids and insertion or removal of grommets.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Weight loss surgery',
                propertyValue: 'Excluded',
                propertyType: 'Hospital',
                qualifyingStatements:
                  'Hospital treatment for surgery that is designed to reduce a person’s weight, remove excess skin due to weight loss and reversal of a bariatric procedure.',
                waitingPeriod: null,
              },
            ],
          },
        ],
      },
    };

    const quoteDetailsResponse = {
      composition: 'family',
      state: '2',
      hospitalAndExtras: 'both',
      keepProduct: true,
      medicalNeedClinical: null,
      medicalNeedExtras: null,
      excludePregnancy: 'false',
      coverReason: 'allRound',
      myCircumstances: null,
      startDate: '2024-11-21',
      mainPolicyHolder: {
        contactId: '7303d34f-fbb4-ee11-a568-000d3ae1a81f',
        preferredCommunicationMode: null,
        previousFunds: [],
        covered: false,
        veteranCard: {
          cardType: null,
          conditions: null,
          hasVeteranCard: false,
        },
        concessionCard: null,
        addressPostal: null,
        lifetimeHealthCoverOverrule: null,
        ageBasedDiscount: null,
        email: 'test@test.com',
        phoneNumbers: [],
        dateOfBirth: '1973-01-01T00:00:00',
        gender: null,
        lastName: 'BenesZeroTwo',
        middleName: null,
        firstName: 'ElaineZeroTwo',
      },
      partner: {
        isSameTransferFund: null,
        previousFunds: null,
        veteranCard: {
          cardType: null,
          conditions: null,
          hasVeteranCard: false,
        },
        concessionCard: null,
        addressPostal: null,
        lifetimeHealthCoverOverrule: null,
        ageBasedDiscount: null,
        email: null,
        phoneNumbers: null,
        dateOfBirth: null,
        gender: null,
        lastName: null,
        middleName: null,
        firstName: null,
      },
      numberOfChildren: null,
      rebate: {
        rebateTier: 'BASE_TIER',
        declarationAcceptance: null,
        declarationAcknowledgement: null,
        declarationDate: null,
      },
      eligibility: {
        eligibilityType: 'ADF',
        eligibilitySubject: null,
        subjectName: null,
        subjectRank: null,
        subjectRelation: null,
        subjectDepartmentOrCompanyName: null,
        subjectServiceType: null,
        subjectEligibilityType: null,
        enlistmentDate: null,
        dischargeDate: null,
        sercatStatus: null,
        workConnectionName: null,
        declarationIsConfirmed: null,
        declarationDate: null,
        expiryDate: null,
      },
      recommendations: [
        {
          recommendationName: 'Defence Hospital Silver Plus',
          recommendationRanking: 1,
          quoteId: '5c5bb78f-2c77-ef11-a670-000d3a791d02',
          quoteExpired: false,
          excess: '500',
          frequency: 'Fortnightly',
          products: [
            {
              productName: 'Defence Hospital Silver Plus',
              productCode: 'J24999',
              productType: 'Hospital',
              productDescription: 'Hospital cover that meets most needs including heart and vascular procedures',
              productExcess: '500:750',
              productUSP: 'Hospital cover that meets most needs including heart and vascular procedures',
              eligibleForABD: true,
              productGuideLink: 'https://stdhlwebdevdata001.blob.core.windows.net/pdfdocuments/guides/open/DefenceHospitalSilverPlus.pdf',
              productExcessType: 'MEM_EXCESS',
              productProperties: [
                {
                  flexiLimit: false,
                  propertyName: 'Ambulance treatment',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Comprehensive cover for ambulance services by state-appointed ambulance providers across Australia. This includes emergency transport, on the spot treatment, mobile intensive care, air and sea ambulance.   Transport services between hospitals, repatriation to or from a state for non-clinically necessary reasons, or services by patient transport vehicles are not claimable.',
                  waitingPeriod: '2 months',
                },
                {
                  flexiLimit: false,
                  propertyName: 'Assisted reproductive services',
                  propertyValue: 'Excluded',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for fertility treatments or procedures.  For example: retrieval of eggs or sperm, In vitro Fertilisation (IVF), and Gamete Intra-fallopian Transfer (GIFT).  Treatment of the female reproductive system is listed separately under Gynaecology.  Pregnancy and birth-related services are listed separately under Pregnancy and birth.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Back, neck and spine',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the investigation and treatment of the back, neck and spinal column, including spinal fusion.  For example: sciatica, prolapsed or herniated disc, spinal disc replacement and spine curvature disorders such as scoliosis, kyphosis and lordosis.  Joint replacements are listed separately under Joint replacements.  Joint fusions are listed separately under Bone, joint and muscle.  Spinal cord conditions are listed separately under Brain and nervous system.  Management of back pain is listed separately under Pain management. Pain management that requires a device is listed separately under Pain management with device.  Chemotherapy and radiotherapy for cancer is listed separately under Chemotherapy, radiotherapy and immunotherapy for cancer.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Blood',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the investigation and treatment of blood and blood-related conditions.  For example: blood clotting disorders and bone marrow transplants.  Treatment for cancers of the blood is listed separately under Chemotherapy, radiotherapy and immunotherapy for cancer.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Bone, joint and muscle',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the investigation and treatment of diseases, disorders and injuries of the musculoskeletal system.  For example: carpal tunnel, fractures, hand surgery, joint fusion, bone spurs, osteomyelitis and bone cancer.  Chest surgery is listed separately under Lung and chest.  Spinal cord conditions are listed separately under Brain and nervous system.  Spinal column conditions are listed separately under Back, neck and spine.  Joint reconstructions are listed separately under Joint reconstructions.  Joint replacements are listed separately under Joint replacements.  Podiatric surgery performed by a registered podiatric surgeon is listed separately under Podiatric surgery (provided by a registered podiatric surgeon).  Management of back pain is listed separately under Pain management. Pain management that requires a device is listed separately under Pain management with device.  Chemotherapy and radiotherapy for cancer is listed separately under Chemotherapy, radiotherapy and immunotherapy for cancer.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Brain and nervous system',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the investigation and treatment of the brain, brain-related conditions, spinal cord and peripheral nervous system.  For example: stroke, brain or spinal cord tumours, head injuries, epilepsy and Parkinson’s disease.  Treatment of spinal column (back bone) conditions is listed separately under Back, neck and spine.  Chemotherapy and radiotherapy for cancer is listed separately under Chemotherapy, radiotherapy and immunotherapy for cancer.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Breast surgery (medically necessary) ',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the investigation and treatment of breast disorders and associated lymph nodes, and reconstruction and/or reduction following breast surgery or a preventative mastectomy.  For example: breast lesions, breast tumours, asymmetry due to breast cancer surgery, and gynecomastia.  This clinical category does not require benefits to be paid for cosmetic breast surgery that is not medically necessary.  Chemotherapy and radiotherapy for cancer is listed separately under Chemotherapy, radiotherapy and immunotherapy for cancer.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Cataracts ',
                  propertyValue: 'Excluded',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for surgery to remove a cataract and replace with an artificial lens.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Chemotherapy, radiotherapy and immunotherapy for cancer',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for chemotherapy, radiotherapy and immunotherapy for the treatment of cancer or benign tumours.  Surgical treatment of cancer is listed separately under each body system.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Dental surgery',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for surgery to the teeth and gums.  For example: surgery to remove wisdom teeth, and dental implant surgery.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Diabetes management (excluding insulin pumps)',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the investigation and management of diabetes.  For example: stabilisation of hypo- or hyper- glycaemia, contour problems due to insulin injections.  Treatment for diabetes-related conditions is listed separately under each body system affected. For example, treatment for diabetes-related eye conditions is listed separately under Eye.  Treatment for ulcers is listed separately under Skin.  Provision and replacement of insulin pumps is listed separately under Insulin pumps.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Dialysis for chronic kidney failure',
                  propertyValue: 'Excluded',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for dialysis treatment for chronic kidney failure.  For example: peritoneal dialysis and haemodialysis.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Digestive system',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the investigation and treatment of the digestive system, including the oesophagus, stomach, gall bladder, pancreas, spleen, liver and bowel.  For example: oesophageal cancer, irritable bowel syndrome, gall stones and haemorrhoids.  Endoscopy is listed separately under Gastrointestinal endoscopy.  Hernia and appendicectomy procedures are listed separately under Hernia and appendix.  Bariatric surgery is listed separately under Weight loss surgery.  Chemotherapy and radiotherapy for cancer is listed separately under Chemotherapy, radiotherapy and immunotherapy for cancer.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Ear, nose and throat',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the investigation and treatment of the ear, nose, throat, middle ear, thyroid, parathyroid, larynx, lymph nodes and related areas of the head and neck.  For example: damaged ear drum, sinus surgery, removal of foreign bodies, stapedectomy and throat cancer.  Tonsils, adenoids and grommets are listed separately under Tonsils, adenoids and grommets.  The implantation of a hearing device is listed separately under Implantation of hearing devices.  Orthopaedic neck conditions are listed separately under Back, neck and spine.  Sleep studies are listed separately under Sleep studies.  Chemotherapy and radiotherapy for cancer is listed separately under Chemotherapy, radiotherapy and immunotherapy for cancer.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Eye (not cataracts) ',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the investigation and treatment of the eye and the contents of the eye socket.  For example: retinal detachment, tear duct conditions, eye infections and medically managed trauma to the eye.  Cataract procedures are listed separately under Cataracts.  Eyelid procedures are listed separately under Plastic and reconstructive surgery.  Chemotherapy and radiotherapy for cancer is listed separately under Chemotherapy, radiotherapy and immunotherapy for cancer.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Gastrointestinal endoscopy',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the diagnosis, investigation and treatment of the internal parts of the gastrointestinal system using an endoscope.  For example: colonoscopy, gastroscopy, endoscopic retrograde cholangiopancreatography (ERCP).  Non-endoscopic procedures for the digestive system are listed separately under Digestive system.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Gynaecology ',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the investigation and treatment of the female reproductive system.  For example: endometriosis, polycystic ovaries, female sterilisation and cervical cancer.  Fertility treatments are listed separately under Assisted reproductive services.  Pregnancy and birth-related conditions are listed separately under Pregnancy and birth.  Miscarriage or termination of pregnancy is listed separately under Miscarriage and termination of pregnancy.  Chemotherapy and radiotherapy for cancer is listed separately under Chemotherapy, radiotherapy and immunotherapy for cancer.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Heart and vascular system',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the investigation and treatment of the heart, heart-related conditions and vascular system.  For example: heart failure and heart attack, monitoring of heart conditions, varicose veins and removal of plaque from arterial walls.  Chemotherapy and radiotherapy for cancer is listed separately under Chemotherapy, radiotherapy and immunotherapy for cancer.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Hernia and appendix',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the investigation and treatment of a hernia or appendicitis.  Digestive conditions are listed separately under Digestive system.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Hospital psychiatric services',
                  propertyValue: 'Restricted',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the treatment and care of patients with psychiatric, mental, addiction or behavioural disorders.  For example: psychoses such as schizophrenia, mood disorders such as depression, eating disorders and addiction therapy.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Implantation of hearing devices',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment to correct hearing loss, including implantation of a prosthetic hearing device.  Stapedectomy is listed separately under Ear, nose and throat.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Insulin pumps',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the provision and replacement of insulin pumps for treatment of diabetes.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Joint reconstructions',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for surgery for joint reconstructions.  For example: torn tendons, rotator cuff tears and damaged ligaments.  Joint replacements are listed separately under Joint replacements.  Bone fractures are listed separately under Bone, joint and muscle.  Procedures to the spinal column are listed separately under Back, neck and spine.  Podiatric surgery performed by a registered podiatric surgeon is listed separately under Podiatric surgery (provided by a registered podiatric surgeon).',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Joint replacements',
                  propertyValue: 'Excluded',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for surgery for joint replacements, including revisions, resurfacing, partial replacements and removal of prostheses.  For example: replacement of shoulder, wrist, finger, hip, knee, ankle and toe joints.  Joint fusions are listed separately under Bone, joint and muscle.  Spinal fusions are listed separately under Back, neck and spine.  Joint reconstructions are listed separately under Joint reconstructions.  Podiatric surgery performed by a registered podiatric surgeon is listed separately under Podiatric surgery (provided by a registered podiatric surgeon).',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Kidney and bladder',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the investigation and treatment of the kidney, adrenal gland and bladder.  For example: kidney stones, adrenal gland tumour and incontinence.  Dialysis is listed separately under Dialysis for chronic kidney failure.  Chemotherapy and radiotherapy for cancer is listed separately under Chemotherapy, radiotherapy and immunotherapy for cancer.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Lung and chest',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the investigation and treatment of the lungs, lung-related conditions, mediastinum and chest.  For example: lung cancer, respiratory disorders such as asthma, pneumonia, and treatment of trauma to the chest.  Chemotherapy and radiotherapy for cancer is listed separately under Chemotherapy, radiotherapy and immunotherapy for cancer.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Male reproductive system',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the investigation and treatment of the male reproductive system including the prostate.  For example: male sterilisation, circumcision and prostate cancer.  Chemotherapy and radiotherapy for cancer is listed separately under Chemotherapy, radiotherapy and immunotherapy for cancer.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Miscarriage and termination of pregnancy',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the investigation and treatment of a miscarriage or for termination of pregnancy.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Pain management',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for pain management that does not require the insertion or surgical management of a device.  For example: treatment of nerve pain and chest pain due to cancer by injection of a nerve block.  Pain management using a device (for example an infusion pump or neurostimulator) is listed separately under Pain management with device.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Pain management with device',
                  propertyValue: 'Excluded',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the implantation, replacement or other surgical management of a device required for the treatment of pain.  For example: treatment of nerve pain, back pain, and pain caused by coronary heart disease with a device (for example an infusion pump or neurostimulator).  Treatment of pain that does not require a device is listed separately under Pain management.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Palliative care',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for care where the intent is primarily providing quality of life for a patient with a terminal illness, including treatment to alleviate and manage pain.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Plastic and reconstructive surgery (medically necessary)',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment which is medically necessary for the investigation and treatment of any physical deformity, whether acquired as a result of illness or accident, or congenital.  For example: burns requiring a graft, cleft palate, club foot and angioma.  Plastic surgery that is medically necessary relating to the treatment of a skin-related condition is listed separately under Skin.  Chemotherapy and radiotherapy for cancer is listed separately under Chemotherapy, radiotherapy and immunotherapy for cancer.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Podiatric surgery (by a registered podiatric surgeon) ',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the investigation and treatment of conditions affecting the foot and/or ankle, provided by a registered podiatric surgeon, but limited to cover for:  • accommodation; and • the cost of a prosthesis as listed in the prostheses list set out in the Private Health Insurance (Prostheses) Rules, as in force from time to time.  Note: Insurers are not required to pay for any other benefits for hospital treatment for this clinical category but may choose to do so.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Pregnancy and birth',
                  propertyValue: 'Excluded',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for investigation and treatment of conditions associated with pregnancy and child birth.  Treatment for the baby is covered under the clinical category relevant to their condition. For example, respiratory conditions are covered under Lung and chest.  Female reproductive conditions are listed separately under Gynaecology.  Fertility treatments are listed separately under Assisted reproductive services.  Miscarriage and termination of pregnancy is listed separately under Miscarriage and termination of pregnancy.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Rehabilitation ',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for physical rehabilitation for a patient related to surgery or illness.  For example: inpatient and admitted day patient rehabilitation, stroke recovery, cardiac rehabilitation.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Skin',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for the investigation and treatment of skin, skin-related conditions and nails. The removal of foreign bodies is also included. Plastic surgery that is medically necessary and relating to the treatment of a skin-related condition is also included.  For example: melanoma, minor wound repair and abscesses.  Removal of excess skin due to weight loss is listed separately under Weight loss surgery.  Chemotherapy and radiotherapy for cancer is listed separately under Chemotherapy, radiotherapy and immunotherapy for cancer.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Sleep studies',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment for the investigation of sleep patterns and anomalies.  For example: sleep apnoea and snoring.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Tonsils, adenoids and grommets',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements: 'Hospital treatment of the tonsils, adenoids and insertion or removal of grommets.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Travel and accommodation',
                  propertyValue: 'Included',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'This cover pays benefits for travel and accommodation related to an eligible hospital admission. When travel between the patient’s home address and the hospital (calculated in a straight line) is over 200km return. Accommodation benefits are payable for either the patient or their accompanying person, in a commercial premises i.e. hotel, Airbnb.',
                  waitingPeriod: null,
                },
                {
                  flexiLimit: false,
                  propertyName: 'Weight loss surgery',
                  propertyValue: 'Excluded',
                  propertyType: 'Hospital',
                  qualifyingStatements:
                    'Hospital treatment for surgery that is designed to reduce a person’s weight, remove excess skin due to weight loss and reversal of a bariatric procedure.  For example: gastric banding, gastric bypass, sleeve gastrectomy.',
                  waitingPeriod: null,
                },
              ],
            },
          ],
        },
      ],
      existingProducts: {
        existingProductName: 'Core Hospital Silver & Value Extras',
        products: [
          {
            productName: 'Value Extras',
            productCode: 'I4',
            productType: 'Extras',
            productDescription: 'Cover for a wide range of extras with great annual limits. Generous annual limits on a wide range of extras.  ',
            productExcess: '',
            productUSP: 'Generous annual limits on a wide range of extras.',
            eligibleForABD: false,
            productGuideLink: 'https://stdhlwebdevdata001.blob.core.windows.net/pdfdocuments/guides/open/ValueExtras.pdf',
            productExcessType: '',
            productProperties: [
              {
                flexiLimit: false,
                propertyName: 'Ambulance treatment',
                propertyValue: '$ Unlimited',
                propertyType: 'Extras',
                qualifyingStatements:
                  "Comprehensive cover for ambulance services by state-appointed ambulance providers across Australia. No limits apply, so there's no need for a separate subscription. Cover includes: emergency services, non-emergency dispatch, mobile intensive care, air and sea ambulance services. Transport services by Patient Transport vehicles are not ambulance services and are not claimable",
                waitingPeriod: '2 months',
              },
              {
                flexiLimit: true,
                propertyName: 'Antenatal and postnatal services',
                propertyValue: 'Included',
                propertyType: 'Extras',
                qualifyingStatements:
                  'Antenatal services are provided before having a baby and postnatal services are provided after having a baby. Benefits are payable for consultations and classes with a midwife or physiotherapist in private practice. Treatment claims through Medicare cannot be covered.',
                waitingPeriod: null,
              },
              {
                flexiLimit: true,
                propertyName: 'Audiology',
                propertyValue: 'Included',
                propertyType: 'Extras',
                qualifyingStatements: null,
                waitingPeriod: null,
              },
              {
                flexiLimit: true,
                propertyName: 'Chiropractic/Osteopathic',
                propertyValue: 'Included',
                propertyType: 'Extras',
                qualifyingStatements: null,
                waitingPeriod: null,
              },
              {
                flexiLimit: true,
                propertyName: 'Dietitian',
                propertyValue: 'Included',
                propertyType: 'Extras',
                qualifyingStatements: null,
                waitingPeriod: null,
              },
              {
                flexiLimit: true,
                propertyName: 'Exercise physiology',
                propertyValue: 'Included',
                propertyType: 'Extras',
                qualifyingStatements: null,
                waitingPeriod: null,
              },
              {
                flexiLimit: true,
                propertyName: 'Eye therapy',
                propertyValue: 'Included',
                propertyType: 'Extras',
                qualifyingStatements: null,
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Flexi-limit',
                propertyValue: '$1100 per person',
                propertyType: 'Extras',
                qualifyingStatements:
                  'The flexi-limit can be claimed across the range of included treatments, or you can choose to use it all on your favourite included treatment.',
                waitingPeriod: '2 months',
              },
              {
                flexiLimit: false,
                propertyName: 'General and preventive dental',
                propertyValue: '$900 per person',
                propertyType: 'Extras',
                qualifyingStatements:
                  'Includes examinations, scale & clean, fluoride treatments, x-rays, simple extractions, most fillings, mouth-guards and other simple, dental treatments. *Some dental items are limited in the number of times they can be claimed in a year or appointment. Some are not payable in combination with others. And some may not attract a benefit at all.',
                waitingPeriod: '2 months',
              },
              {
                flexiLimit: false,
                propertyName: 'Health and wellbeing',
                propertyValue: '$300 per person',
                propertyType: 'Extras',
                qualifyingStatements:
                  'Where the provider is recognised by the Australian Regional Health Group the following alternative therapies are payable: acupuncture, myotherapy and remedial massage. No benefit payable for any prescribed medications, herbal or dietary preparations. Included in this category is physiotherapy group therapy sessions and classes and excerise physiology group therapy. Benefits are available for approved health screening tests and programs.',
                waitingPeriod: '2 months',
              },
              {
                flexiLimit: false,
                propertyName: 'Laser refractive eye surgery',
                propertyValue: 'Excluded',
                propertyType: 'Extras',
                qualifyingStatements: 'Payable for LASIK, PRK or smile eye surgery in recognised day surgery centre every 2 financial years.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Major dental',
                propertyValue: '$900 per person',
                propertyType: 'Extras',
                qualifyingStatements: 'Complex dental services such as root canal therapy, surgical extractions, gum disease, dentures, implants, crowns and bridges.',
                waitingPeriod: '12 months',
              },
              {
                flexiLimit: false,
                propertyName: 'Medically prescribed devices and appliances',
                propertyValue: '$1000 per person',
                propertyType: 'Extras',
                qualifyingStatements:
                  'A wide range of aids and appliances that help treat or supporta medial condition. Common examples include hearing aids, PAP machines, blood glucose monitors, mobility aids, compression garments, foot orthotics and nebulisers.',
                waitingPeriod: '2-12 months',
              },
              {
                flexiLimit: true,
                propertyName: 'Occupational therapy',
                propertyValue: 'Included',
                propertyType: 'Extras',
                qualifyingStatements: null,
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Optical',
                propertyValue: '$255 per person',
                propertyType: 'Extras',
                qualifyingStatements: 'Provision of presciption glasses and contact lenses.',
                waitingPeriod: '2 months',
              },
              {
                flexiLimit: false,
                propertyName: 'Orthodontics',
                propertyValue: '$800 per person',
                propertyType: 'Extras',
                qualifyingStatements: 'Dental services to address and realign bites',
                waitingPeriod: '12 months',
              },
              {
                flexiLimit: true,
                propertyName: 'Pharmacy and vaccinations',
                propertyValue: 'Included',
                propertyType: 'Extras',
                qualifyingStatements: 'The benefit is payable on non-PBS pharmaceuticals only and applies to the cost in excess of the current PBS amount.',
                waitingPeriod: null,
              },
              {
                flexiLimit: true,
                propertyName: 'Physiotherapy',
                propertyValue: 'Included',
                propertyType: 'Extras',
                qualifyingStatements: null,
                waitingPeriod: null,
              },
              {
                flexiLimit: true,
                propertyName: 'Podiatry/Chiropody',
                propertyValue: 'Included',
                propertyType: 'Extras',
                qualifyingStatements: null,
                waitingPeriod: null,
              },
              {
                flexiLimit: true,
                propertyName: 'Psychology',
                propertyValue: 'Included',
                propertyType: 'Extras',
                qualifyingStatements: 'Treatment claimed through Medicare cannot be covered.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'School accidents',
                propertyValue: '$600 per person',
                propertyType: 'Extras',
                qualifyingStatements:
                  'Additional benefits for costs resulting from a school accident to your child. To cover the gaps after your extras benefits have been provided, excludes Medicare services.',
                waitingPeriod: '2 months',
              },
              {
                flexiLimit: true,
                propertyName: 'Speech therapy',
                propertyValue: 'Included',
                propertyType: 'Extras',
                qualifyingStatements: null,
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Surgical tooth removal',
                propertyValue: 'Included with Major dental',
                propertyType: 'Extras',
                qualifyingStatements: null,
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Travel vaccinations',
                propertyValue: 'Excluded',
                propertyType: 'Extras',
                qualifyingStatements: null,
                waitingPeriod: null,
              },
            ],
          },
          {
            productName: 'Core Hospital Silver',
            productCode: 'J21',
            productType: 'Hospital',
            productDescription: 'Hospital cover tailored to keep costs affordable. Value-packed hospital cover tailored for you.   ',
            productExcess: '500:750',
            productUSP: 'Value-packed hospital cover tailored for you.',
            eligibleForABD: true,
            productGuideLink: 'https://stdhlwebdevdata001.blob.core.windows.net/pdfdocuments/guides/open/CoreHospitalSilverPlus.pdf',
            productExcessType: 'MEM_EXCESS',
            productProperties: [
              {
                flexiLimit: false,
                propertyName: 'Assisted reproductive services',
                propertyValue: 'Excluded',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for fertility treatments or procedures.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Back, neck and spine',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the investigation and treatment of the back, neck and spinal column, including spinal fusion.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Blood',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the investigation and treatment of blood and blood-related conditions.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Bone, joint and muscle',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the investigation and treatment of diseases, disorders and injuries of the musculoskeletal system.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Brain and nervous system',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the investigation and treatment of the brain, brain-related conditions, spinal cord and peripheral nervous system.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Breast surgery (medically necessary)',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements:
                  'Hospital treatment for the investigation and treatment of breast disorders and associated lymph nodes, and reconstruction and/or reduction following breast surgery or a preventative mastectomy. This clinical category does not require benefits to be paid for cosmetic breast surgery that is not medically necessary.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Cataracts',
                propertyValue: 'Excluded',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for surgery to remove a cataract and replace with an artificial lens.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Chemotherapy, radiotherapy and immunotherapy for cancer',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for chemotherapy, radiotherapy and immunotherapy for the treatment of cancer or benign tumours.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Dental surgery',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for surgery to the teeth and gums.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Diabetes management (excluding insulin pumps)',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the investigation and management of diabetes.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Dialysis for chronic kidney failure',
                propertyValue: 'Excluded',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for dialysis treatment for chronic kidney failure.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Digestive system',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements:
                  'Hospital treatment for the investigation and treatment of the digestive system, including the oesophagus, stomach, gall bladder, pancreas, spleen, liver and bowel.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Ear, nose and throat',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements:
                  'Hospital treatment for the investigation and treatment of the ear, nose, throat, middle ear, thyroid, parathyroid, larynx, lymph nodes and related areas of the head and neck.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Eye (not cataracts)',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the investigation and treatment of the eye and the contents of the eye socket.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Gastrointestinal endoscopy',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the diagnosis, investigation and treatment of the internal parts of the gastrointestinal system using an endoscope.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Gynaecology',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the investigation and treatment of the female reproductive system.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Heart and vascular system',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the investigation and treatment of the heart, heart-related conditions and vascular system.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Hernia and appendix',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the investigation and treatment of a hernia or appendicitis.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Hospital psychiatric services',
                propertyValue: 'Restricted',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the treatment and care of patients with psychiatric, mental, addiction or behavioural disorders.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Implantation of hearing devices',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment to correct hearing loss, including implantation of a prosthetic hearing device.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Insulin pumps',
                propertyValue: 'Excluded',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the provision and replacement of insulin pumps for treatment of diabetes.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Joint reconstructions',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for surgery for joint reconstructions.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Joint replacements',
                propertyValue: 'Excluded',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for surgery for joint replacements, including revisions, resurfacing, partial replacements and removal of prostheses.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Kidney and bladder',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the investigation and treatment of the kidney, adrenal gland and bladder.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Lung and chest',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the investigation and treatment of the lungs, lung-related conditions, mediastinum and chest.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Male reproductive system',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the investigation and treatment of the male reproductive system including the prostate.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Miscarriage and termination of pregnancy',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the investigation and treatment of a miscarriage or for termination of pregnancy.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Pain management',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for pain management that does not require the insertion or surgical management of a device.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Pain management with device',
                propertyValue: 'Excluded',
                propertyType: 'Hospital',
                qualifyingStatements:
                  'Hospital treatment for the implantation, replacement or other surgical management of a device required for the treatment of pain. For example: treatment of nerve pain, back pain, and pain caused by coronary heart disease with a device (for example an infusion pump or neurostimulator). Treatment of pain that does not require a device is listed separately under Pain management.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Palliative care',
                propertyValue: 'Restricted',
                propertyType: 'Hospital',
                qualifyingStatements:
                  'Hospital treatment for care where the intent is primarily providing quality of life for a patient with a terminal illness, including treatment to alleviate and manage pain.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Plastic and reconstructive surgery (medically necessary)',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements:
                  'Hospital treatment which is medically necessary for the investigation and treatment of any physical deformity, whether acquired as a result of illness or accident, or congenital.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Podiatric surgery (by a registered podiatric surgeon)',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements:
                  'Hospital treatment for the investigation and treatment of conditions affecting the foot and/or ankle, provided by a registered podiatric surgeon but limited to cover for:· accommodation; and· the cost of a prosthesis as listed in the prostheses list set out in the Private Health Insurance (Prostheses) Rules, as in force from time to time.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Pregnancy and birth',
                propertyValue: 'Excluded',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for investigation and treatment of conditions associated with pregnancy and child birth.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Rehabilitation',
                propertyValue: 'Restricted',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for physical rehabilitation for a patient related to surgery or illness.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Skin',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements:
                  'Hospital treatment for the investigation and treatment of skin, skin-related conditions and nails. The removal of foreign bodies is also included.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Sleep studies',
                propertyValue: 'Excluded',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment for the investigation of sleep patterns and anomalies.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Tonsils, adenoids and grommets',
                propertyValue: 'Included',
                propertyType: 'Hospital',
                qualifyingStatements: 'Hospital treatment of the tonsils, adenoids and insertion or removal of grommets.',
                waitingPeriod: null,
              },
              {
                flexiLimit: false,
                propertyName: 'Weight loss surgery',
                propertyValue: 'Excluded',
                propertyType: 'Hospital',
                qualifyingStatements:
                  'Hospital treatment for surgery that is designed to reduce a person’s weight, remove excess skin due to weight loss and reversal of a bariatric procedure.',
                waitingPeriod: null,
              },
            ],
          },
        ],
      },
    };

    return AwaitResponse(isScenarioTwo ? quoteDetailsResponse : recommendationsResponse);
  }

  static async getTerminationReasonFlexCodes() {
    return AwaitResponse(terminationReasonFlexCodes.terminationReasons);
  }

  static async getFundNames() {
    return AwaitResponse(fundNames.value);
  }

  static async getPrice() {
    const recommendationPrices = {
      productPrices: [
        {
          calculationResultSetTotalResult: 123.15,
          enrollmentProductCode: ['J18'],
          discounts: {
            dvaDiscount: '-25%',
            transitionDiscount: '-10%',
            reservistDiscount: '-5%',
          },
        },
        {
          enrollmentProductCode: ['J22', 'I4'],
          calculationResultSetTotalBasePremium: 200.77,
          calculationResultSetTotalSurcharge: 33.2,
          calculationResultSetTotalAdjustment: -33.2,
          calculationResultSetTotalResult: 200.77,
        },
      ],
    };

    // transform `enrollmentProductCode` to `productCodes` for each productPrice, to map the response structure of the CMS BE API to FE expected structure
    recommendationPrices.productPrices = recommendationPrices.productPrices.map((productPrice) => {
      return { ...productPrice, productCodes: productPrice.enrollmentProductCode };
    });

    return AwaitResponse(recommendationPrices);
  }

  static async getPersonOverCoverage() {
    return AwaitResponse({
      duplicateMembers: [
        {
          personCode: 'string',
          coveredMemberships: [
            {
              memberNumber: 'string',
              policyIsApprovedStatus: true,
              products: ['string'],
              productsInformation: [
                {
                  productName: 'Advantage silver plus',
                  productCode: 'J21',
                  productTypeCode: 'E', // H, E, P
                  productTypeDescr: 'Extras', // Hospital, Extras, Package
                },
              ],
            },
          ],
        },
      ],
    });
  }

  /**
   * API Call to check if a person is a duplicate
   * @param {string} firstName - Pass firstName as 'duplicate' to get a duplicate=true response
   * @param {string} lastName - Pass lastName as 'fail' to get a API failure response
   */
  static async isPersonDuplicate(firstName, lastName) {
    let fail = false;
    let isDuplicate = false;
    if (firstName === 'duplicate') {
      isDuplicate = true;
    }
    if (lastName === 'fail') {
      fail = true;
    }

    return AwaitResponse(isDuplicate, fail);
  }

  static async raiseDuplicatePersonWorkItem() {
    return AwaitResponse({});
  }

  static async submitChangeCover() {
    return AwaitResponse({
      currentPremium: 281.49,
      newPremium: 302.5,
      currentPayFrequency: 'fortnightly',
      newPayFrequency: 'fortnightly',
      currentDate: '2024-02-09',
      changeStartDate: '2024-02-09',
      composition: {
        op: 'none',
        value: 'family',
      },
      state: {
        op: 'none',
        value: 'ACT',
      },
      postcode: {
        op: 'none',
        value: '2905',
      },
      terminations: {
        products: [
          {
            productCode: 'I4',
            terminationReason: 'AFF',
            fundName: null,
          },
          {
            productCode: 'J22',
            terminationReason: 'AFF',
            fundName: null,
          },
        ],
        partner: {
          personCode: '25268',
          terminationReason: 'TAF',
          fundName: 'NIB',
        },
        children: null,
      },
      residentialAddress: {
        op: 'none',
        dpId: '53717247',
        addressType: null,
        addressLine1: '51 Johnson Dr',
        addressLine2: null,
        addressLine3: null,
        suburb: 'CALWELL',
        postcode: '2905',
        state: 'ACT',
        stateLastModified: null,
      },
      mainPolicyHolder: {
        op: 'none',
        cda: null,
        lifetimeHealthCoverOverrule: null,
        personCode: '8434',
        postalAddress: {
          op: 'none',
          dpId: '53717247',
          addressType: 'S',
          addressLine1: '51 Johnson Dr',
          addressLine2: null,
          addressLine3: null,
          suburb: 'CALWELL',
          postcode: '2905',
          state: 'ACT',
          stateLastModified: null,
        },
        veteranCard: {
          hasVeteranCard: false,
          veteranCardList: [],
        },
        concessionCard: {
          hasConcessionCard: true,
          cardList: [
            {
              op: 'none',
              id: '66587',
              cardType: 'CSHC',
              cardNumber: '123456789Y',
              expiryDate: '',
              startDate: '2024-01-22',
              endDate: null,
            },
          ],
          lastModified: null,
        },
      },
      partner: {
        op: 'add',
        personCode: 'Member-100200000000',
        veteranCard: {
          hasVeteranCard: true,
          veteranCardList: [
            {
              op: 'add',
              id: null,
              cardType: 'WHITE',
              acceptedConditions: [
                {
                  op: 'add',
                  id: null,
                  code: 'DVAC2',
                  startDate: '2024-02-09',
                  endDate: null,
                },
                {
                  op: 'add',
                  id: null,
                  code: 'DVAC7',
                  startDate: '2024-02-09',
                  endDate: null,
                },
              ],
              startDate: '2024-02-09',
              endDate: null,
            },
          ],
        },
        concessionCard: {
          hasConcessionCard: true,
          cardList: [],
          lastModified: null,
        },
        postalAddress: {
          op: 'add',
          dpId: '53717247',
          addressType: null,
          addressLine1: '51 Johnson Dr',
          addressLine2: null,
          addressLine3: null,
          suburb: 'CALWELL',
          postcode: '2905',
          state: 'ACT',
          stateLastModified: null,
        },
        isSameTransferFund: false,
        previousFunds: [],
        lifetimeHealthCoverOverrule: null,
        email: 'test@email.com',
        work: null,
        home: null,
        mobile: '0400000000',
        dateOfBirth: '2000-05-20',
        gender: 'F',
        lastName: 'parrtner lname',
        middleName: '',
        firstName: 'New partner fname',
        cda: 0,
      },
      children: [
        {
          op: 'none',
          personCode: 'Member-1006',
          studentDeclaration: null,
          age: 3,
          isStudent: null,
          studentStartDate: null,
          studentEndDate: null,
          institutionName: null,
          isSameTransferFund: null,
          previousFunds: null,
          dateOfBirth: null,
          gender: null,
          lastName: null,
          middleName: null,
          firstName: null,
          cda: 0,
        },
      ],
      eligibility: {
        op: 'replace',
        eligibilityType: 'ExServing',
        eligibilitySubject: 'Self',
        subjectName: null,
        subjectRank: 'Rank',
        subjectRelation: '',
        subjectDepartmentOrCompanyName: 'Airforce',
        subjectServiceType: 'Reservist',
        subjectEligibilityType: '',
        enlistmentDate: '2023-11-11',
        dischargeDate: '2023-12-13',
        sercatStatus: '',
        workConnectionName: '',
        declarationIsConfirmed: true,
        declarationDate: '2024-02-09',
        expiryDate: '',
      },
      rebate: {
        op: 'none',
        rebateTier: 'none',
        rebateApplicant: '25268',
        medicareCard: {
          cardType: null,
          medicareCardNumber: null,
          expiryDate: null,
          firstName: null,
          lastName: null,
        },
      },
      productList: [
        {
          op: 'replace',
          productCode: 'J19',
          excess: '500',
          productExcessType: 'MEM_EXCESS',
        },
        {
          op: 'add',
          productCode: 'I3',
          excess: null,
          productExcessType: null,
        },
      ],
    });
  }

  static async postEmailQuote() {
    const successResponse = {
      emailId: 'quotesent@changeproduct.com',
    };

    //   const invalidEmailIdResponse = {
    //     "error": {
    //       "name": "InvalidEmail",
    //       "code": "invalidEmailAddress",
    //       "errorMessage": "Invalid email found on Contact record. Please provide an alternative contact email address."
    //     }
    //   };

    //   const errorResponse = {
    //     "errorMessage": 'string'
    //   };

    return AwaitResponse(successResponse, false);
  }

  static getMemberPolicies() {
    return AwaitResponse(MemberPolicies);
  }
}
